import { getFlagEmoji } from '@app/utils/helpers';
import { EmissionsCategoryEnum } from '@shared/api/types';
import Text from '@shared/components/content/text';
import Unit from '@shared/components/content/unit';
import RatingCloud from '@shared/components/ratings/rating-cloud';
import { roundNumberToNDecimalPlaces } from '@shared/lib/utils';
import React from 'react';

interface FoodEmissionsBoxProps {
  name: string;
  totalEmissionsPerKg: number | null;
  emissionsCategory: EmissionsCategoryEnum | null;
  uuid: string;
  countryOfOrigin: string | null;
}

const FoodEmissionsBox: React.FC<FoodEmissionsBoxProps> = ({
  name,
  totalEmissionsPerKg,
  emissionsCategory,
  countryOfOrigin,
}) => {
  return (
    <div className="mt-2.5 flex rounded-md bg-gray-00 p-2">
      <div className="flex items-center">
        <RatingCloud rating={emissionsCategory} />
        <Text className="ml-5 mt-1">
          {name}
          {countryOfOrigin && <>(origin: {getFlagEmoji(countryOfOrigin)})</>}
        </Text>
      </div>
      <div className="ml-auto">
        {totalEmissionsPerKg !== null && (
          <div className="float-right mr-5 mt-1 flex items-baseline whitespace-nowrap font-medium">
            <span className="font-bold">
              {roundNumberToNDecimalPlaces(totalEmissionsPerKg, 2, true)}
            </span>
            <Unit variant="kgCO2e/kg" className="ml-1" />
          </div>
        )}
      </div>
    </div>
  );
};

export default FoodEmissionsBox;
